import { render, staticRenderFns } from "./NoFoto.vue?vue&type=template&id=3e74cbc6&"
import script from "./NoFoto.vue?vue&type=script&lang=ts&"
export * from "./NoFoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports